var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AgentReleaseStatus } from "healthex-common/agent.release.dtos";
import { observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
import { willNeverHappen } from "healthex-common/utils";
export class GlobalAdminAgentReleasesListViewModel {
    constructor(container) {
        this.agentReleases = NOT_LOADED;
        this.agentReleaseService = container.agentReleaseService;
        this.routingUIManager = container.routingUIManager;
        void this.loadAgentReleases();
    }
    async loadAgentReleases() {
        let minimumVersionFound = false;
        this.agentReleases = (await this.agentReleaseService.getAgentReleases()).map((release) => {
            const result = {
                ...release,
                uiStatus: this.getUIStatus(release.status, minimumVersionFound),
            };
            minimumVersionFound = minimumVersionFound || release.minimumVersion;
            return result;
        });
    }
    getUIStatus(status, isUnsupported) {
        if (isUnsupported) {
            return "Unsupported";
        }
        else {
            switch (status) {
                case AgentReleaseStatus.ACTIVE:
                    return "Supported";
                case AgentReleaseStatus.DEPRECATED:
                    return "Deprecated";
                case AgentReleaseStatus.WITHDRAWN:
                    return "Withdrawn";
            }
            return willNeverHappen(status);
        }
    }
    async createAgentRelease() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASE_NEW);
    }
    async editAgentRelease(release) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AGENT_RELEASE_EDIT, { id: release.id });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], GlobalAdminAgentReleasesListViewModel.prototype, "agentReleases", void 0);
